import React, { useEffect, useRef, useState } from 'react';
import noRecordFound from '../../../assets/images/empty-folder.png'
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setAnnouncementlist } from '../../../redux/slices/announcementSlice';
import DOMPurify from "dompurify";
import { getCurrentMonth } from '../../Dashboard/DashBoardHelper';
import { cleanAndTruncateText, useIsMobile } from '../../../hooks/commonHooks';
import dayjs from 'dayjs';
import EventLoader from '../../../components/Loader/EventLoader';


export interface EmailRecipient {
  emailRecipientId: number;
  toEmail: string | null;
  ccEmail: string | null;
  bccEmail: string | null;
}

export interface Announcement {
  emailAnnouncementId: number;
  senderCntUserId: number;
  subject: string;
  body: string;
  status: string;
  scheduledTime: string | null;
  isStarred: boolean;
  attachments: any[];
  emailRecipient: EmailRecipient;
  isActive: boolean;
  createdOn: string;
  organisationId: number;
}
function UserAnnouncement(props: any) {

  const { title, announcementList } = props;

  const [currMonth, setCurrMonth] = useState<any>();
  const [loader, setLoader] = useState<any>(true);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [scrollDirection, setScrollDirection] = useState<'up' | 'down'>('down');
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  useEffect(() => {
    setCurrMonth(getCurrentMonth());
    setTimeout(() => {
      setLoader(false);
    }, 3500);
  }, []);


  const handleNavigateToAnnouncement = (item: Announcement) => {
    if (item) {
      dispatch(setAnnouncementlist(item));
      navigate(`/announcements/single-announcements/${item?.emailAnnouncementId}`);
    }
  }

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
      if (scrollTop + clientHeight >= scrollHeight) {
        setScrollDirection('up');
      } else if (scrollTop <= 0) {
        setScrollDirection('down');
      }
    };

    const scrollSpeed = 1.5;
    const intervalDelay = 10;
    let autoScroll: ReturnType<typeof setInterval> | null = null;

    if (!isHovered) {
      autoScroll = setInterval(() => {
        if (scrollDirection === 'down') {
          scrollContainer.scrollBy({ top: scrollSpeed, behavior: 'smooth' });
        } else {
          scrollContainer.scrollBy({ top: -scrollSpeed, behavior: 'smooth' });
        }
        handleScroll();
      }, intervalDelay);
    }

    return () => {
      if (autoScroll) clearInterval(autoScroll);
    };
  }, [scrollDirection, isHovered]);

  const handleMouseOver = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);



  const renderAnnouncement = (item: any) => {
    const sanitizeAnnouncementContent = (announcementContent: string) => {
      const sanitizedBody = announcementContent ? DOMPurify.sanitize(announcementContent) : '';
      return sanitizedBody;
    }
    const plainTextBody = item && item.body ? item.body : '';
    const truncatedBody = cleanAndTruncateText(plainTextBody);
    return (
      <div className={`birth-anniversary__list-cont items-center cursor-pointer hover:text-[#d34a7c]`}
        onClick={() => {
          handleNavigateToAnnouncement(item)
        }}>
        <div className='birth-anniversary__profile-img flex justify-center items-center'>
          <span className="material-symbols-outlined text-[#d23b7d]">
            campaign
          </span>
        </div>

        <div className=' birth-anniversary__emp-hooray flex cursor-pointer hover:text-[#d34a7c]'>
          <span> <p className='dashboard-announce-body hover:text-[#d34a7c]' > {item?.subject}</p></span>

          <span className='dashboard-announce-body hover:text-[#d34a7c]'>
            <div dangerouslySetInnerHTML={{ __html: sanitizeAnnouncementContent(truncatedBody) }} className='announceHtml hover:text-[#d34a7c]' />
          </span>
          {isMobile && <span>
            <p className='dashboard-announce-body opacity-[0.7]' > {item.createdOn && dayjs(item.createdOn).format('MMMM D, YYYY')}</p>
          </span>}

        </div>

      </div>
    )
  }

  return (
    <div className="birth-anniversary relative user--announcement">
      {loader ? (
        <div className="flex items-center justify-center h-[300px]">
          <EventLoader />
        </div>
      ) : announcementList?.data?.length > 0 ? (
        <div
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseLeave}
          className="overflow-y-hidden mt-6 md:mt-12 user-announcement-notification-container  h-[80%]"
        >
          <ul className="birth-anniversary__timeline announcement-notification-content" id="anniversary">
            {announcementList?.data?.slice(0, 4).map((item: any, index: number) => {
              const currDate = new Date(item.updatedOn).getDate();
              const currMonth = new Date(item.updatedOn).toLocaleString("default", { month: "short" });

              const prevDate =
                index > 0
                  ? new Date(announcementList.data[index - 1]?.updatedOn).getDate()
                  : null;

              return (
                <li
                  key={`${item.emailAnnouncementId}+${index}`}
                  className="birth-anniversary__lists relative"
                  id={`date-${currDate}`}
                >
                  {prevDate !== currDate && (
                    <div className="date-header">
                      <span className="birth-anniversary__date absolute items-center flex justify-center">
                        {currDate}
                      </span>
                      <span className="birth-anniversary__month absolute">
                        {currMonth}
                      </span>
                    </div>
                  )}
                  <div className="announcement-content">
                    {renderAnnouncement(item)}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      ) : (
        <div className="no-record user-announcement">
          <p className="flex justify-center items-center text-xl">
            <img src={noRecordFound} alt="no record" />
          </p>
        </div>
      )}
    </div>
  );

}

export default UserAnnouncement;
